"use strict";

export default angular.module("contartemx.administracion.cuentas")
    .controller("NuevaCuentaContribuyenteCtrl", ($scope, $uibModalInstance, cuenta, apiCall, mostrarNotificacion, ServicioValidacion) => {

        $scope.loading = false;

        $scope.contribuyente = {
            CveContribuyente: 0,
        };

        $scope.EsRfcValido = ServicioValidacion.EsRFCValido;

        $scope.closeModal = (respuesta) => {
            $uibModalInstance.dismiss();
        };

        if (!cuenta) {
            $scope.esNueva = 'Crear ';
            $scope.esCuentaNueva = true;
        } else {
            $scope.esCuentaNueva = false;
            $scope.esNueva = 'Editar ';
        }

        $scope.guardarContribuyente = () => {

            $scope.loading = true;

            let datosEnviar = {},
                llamadoEjecutar = (!$scope.contribuyente.CveContribuyente) ? 'CrearContribuyente' : 'EditarContribuyente';
            datosEnviar.Nombre = $scope.contribuyente.Nombre;
            datosEnviar.RFC = $scope.contribuyente.RFC;
            datosEnviar.CveContribuyente = $scope.contribuyente.CveContribuyente;

            $scope.alert = [];

            apiCall.post(llamadoEjecutar, datosEnviar)
                .then((data) => {
                    if (data.EsError) {
                        $scope.alert = [{ msg: data.Mensaje }];
                    } else {
                        $uibModalInstance.close(data);
                    }
                },
                mostrarNotificacion.error)
                .finally(() => $scope.loading = false);

        };

        $scope.closeModalAlert = index => {  
            $scope.alert.splice(index, 1);
        };

    });
